import { ButtonPrimary } from "components/Atoms/Button";
import React, { useCallback } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { DetailSidePanel } from "../DetailSidePanel";
import { useOpenSidePanel } from "../SidePanel";
import { AirportSidePanelDetails } from "./AirportSidePanelDetails";
import { RightClickMenu } from "components/RightClickMenu/RightClickMenuContext";
import { rightMenuForSidePanel } from "components/RightClickMenu/rightClickMenuUtils";

export interface AirportSidePanelProps {
  airportId: number;
  trigger: JSX.Element
  onOpen?: () => void
}

export const AirportSidePanel = (props: AirportSidePanelProps) => {
  return <DetailSidePanel
    detailUrl={routes.airport_Detail(props.airportId).absolute}
    apiCall={() => window.CoreApi.Airport.GetAirport(props.airportId)}
    apiKey="airport"
    entityId={props.airportId}
    title={RESX.Flight.Airport}
    footerContent={<>
      <ButtonPrimary href={routes.airport_Detail(props.airportId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    onOpen={props.onOpen}
    trigger={<RightClickMenu menuItems={rightMenuForSidePanel(routes.airport_Detail(props.airportId).absolute)}>{props.trigger}</RightClickMenu>}
  >
    {(airport) => <AirportSidePanelDetails airport={airport} />}
  </DetailSidePanel>;
}

export const useOpenAirportSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openAirportSidePanel = useCallback((airportId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Airport.GetAirport(airportId)}
      apiKey="airport"
      entityId={airportId}
      title={RESX.Flight.Airport}
      footerContent={<>
        <ButtonPrimary href={routes.airport_Detail(airportId).absolute} label={RESX.Buttons.DetailView} />
      </>}
      skipSidePanelBase
    >
      {(airport) => <AirportSidePanelDetails airport={airport} />}
    </DetailSidePanel>, `airport-side-${airportId}`);
  }, [openSidePanel]);

  return openAirportSidePanel;
}